module.exports = __webpack_public_path__ + "img/y1.01f23139.svg";